export const getTypeAheadGlobalViewMoreId = (listId: string): string => `${listId}-view-all`;
